import styled, { css } from 'styled-components'
import fanta from '@chegg-wt/core/theme/fanta/theme'
import { SolidBoldBorder, LargeRounding } from '@chegg-wt/core/theme/sunkist/borders'
import { ButtonReset } from '@chegg-wt/core/theme/sunkist/resets'
import { values } from '@chegg-wt/core/theme/sunkist/spacing'
import { Body, BodySmall, InputSmall } from '@chegg-wt/core/theme/sunkist/typography'
import {
  Heading as MHeading,
  CancelButton as MCancelButton,
  ConfirmButton as MConfirmButton,
  ButtonContainer as MButtonContainer,
  ButtonContainerMobile as MButtonContainerMobile,
  Container as MContainer,
} from '../styled'

export const Heading = styled(MHeading)``

/**
 * TODO: Revisit once easybib-redesign has been deprecated
 * [1]: Overriding default from easybib-redesign
 */
export const AlertMessage = styled.p`
  ${Body};
  margin-bottom: 0; /* [1] */
`

export const Alert = styled.div`
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor09};
  padding: ${values.xsmall};
  display: flex;

  & > * + * {
    margin-left: ${values.xsmall};
  }
`

/**
 * TODO: Revisit once easybib-redesign has been deprecated
 * [1]: Overriding default from easybib-redesign
 */
export const Label = styled.label`
  ${BodySmall};
  margin-bottom: 0; /* [1] */
`

export const BlockLabel = styled(Label)`
  display: block;
`

/**
 * [1]: This is the color used in https://chegg.invisionapp.com/d/main#/console/15085059/313674035/inspect
 */
export const Input = styled.input`
  ${SolidBoldBorder};
  ${LargeRounding};
  ${InputSmall};
  color: ${({ theme }) => theme.Colors.textColor};
  padding: ${values.xxsmall};
  border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  width: 100%;

  &:focus {
    border-color: ${({ theme }) => theme.Colors.forFonts.fColor14}; /* [1] */
  }
`

export const Field = styled.div`
  margin-bottom: ${fanta.spacing.fanta.lg};
`

export const CancelButton = styled(MCancelButton)``

export const ConfirmButton = styled(MConfirmButton)``

export const ButtonContainer = styled(MButtonContainer)``
export const ButtonContainerMobile = styled(MButtonContainerMobile)``

export const Container = styled(MContainer)``

export const SVGCircleStateIndicator = styled.circle`
  fill: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
`

export const SVGGBackdrop = styled.g<{ isOn: boolean }>`
  ${({ isOn = false }) =>
    isOn
      ? css`
          fill: ${({ theme }) => theme.Colors.forInterface.interfaceColor03};
        `
      : css`
          fill: ${({ theme }) => theme.Colors.forInterface.interfaceColor14};
        `};
`

export const SVGContainer = styled.svg`
  display: inline-block;
  vertical-align: middle;
`

export const Action = styled.button`
  ${ButtonReset};
`
